<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Mine' }">我的题库</el-breadcrumb-item>
				<el-breadcrumb-item>{{ js ? '修改习题册' : '新建习题册' }}</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="p_m_t_20"><exercise-header @namwe="namwe"></exercise-header></div>
		</div>
		<div class="mine_list p_m_t_20 overflow" :style="{ height: height + 'px' }">
			<exercise-list :grades="grades" @delete="Delete" :breadcrumb="breadcrumb" @np="np"></exercise-list>
			<exercise-button ref="exercisebutton" :deleteId="deleteId" :names="names" :grades="grades" :breadcrumb="breadcrumb"></exercise-button>
			<div class="btn p_flex p_f_c">
				<el-button type="success" @click="bc">保存</el-button>
				<!-- <el-button type="warning" >下发</el-button> -->
			</div>
		</div>
	</div>
</template>

<script>
import ExerciseHeader from '../commponents/exerciseHeader.vue';
import ExerciseButton from '../commponents/exerciseButton.vue';
import ExerciseList from '../commponents/exerciseTopic.vue';
export default {
	name: 'Exercise',
	components: {
		ExerciseHeader,
		ExerciseButton,
		ExerciseList
	},
	data() {
		return {
			names: '',
			grades: 0, // 年级
			breadcrumb: 0, // 学科
			js: '',
			jes: [],
			deleteId: [],
			height: 0
		};
	},
	created() {
		if (this.$route.query.ccc && this.$route.query.jkh && this.$route.query.hjs) {
			this.names = this.$route.query.ccc;
			this.grades = this.$route.query.jkh;
			this.breadcrumb = this.$route.query.hjs;
		}
		this.js = this.$route.query.js;
		if (this.$route.query.js) {
			var ojbk = this.$route.query.js.split('|'); //分割完返回过来后是一个数组
			this.$request
				.ajax(this)
				.post('/api_teacher/question_list', {
					ids: ojbk
				})
				.then(res => {
					this.names = this.$route.query.ooo;
					this.grades = res.data.list[0].grade;
					this.breadcrumb = res.data.list[0].subject;
				});
		}
	},
	mounted() {
		this.$refs.exercisebutton.indexInfo();
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Exercise') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head;

			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		np(i) {
			this.jes = [];
			i.forEach(item => {
				this.jes.push(item.id);
			});
		},
		namwe(u, i, o) {
			this.names = u;
			this.grades = i == '' ? 0 : i;
			this.breadcrumb = o == '' ? 0 : o;
		},
		goSingle(i) {
			if (i == 0) {
				this.$router.push('/Mine');
			}
		},
		bc() {
			if (this.names == '') {
				this.$message.error('名称不能为空！');
				return;
			}
			if (this.grades == '') {
				this.$message.error('请选择年级不能为空！');
				return;
			}
			if (this.breadcrumb == '') {
				this.$message.error('请选择学科不能为空！');
				return;
			}
			if (this.jes.length <= 0) {
				this.$message.error('请选择题库！');
				return;
			}
			if (this.$route.query.js) {
				this.$request
					.ajax(this)
					.post('/api_teacher/exercise_book_edit/' + this.$route.query.ll, {
						name: this.names,
						grade: this.grade, // 年级
						subject: this.breadcrumb, // 学科
						question_ids: this.jes /* 题目ID */
					})
					.then(res => {
						// console.log(res)
						this.$router.push('/Mine');
					});
			}

			if (this.$route.query.id) {
				this.$request
					.ajax(this)
					.post('/api_teacher/exercise_book_create', {
						name: this.names,
						grade: this.$route.query.jkh, // 年级
						subject: this.$route.query.hjs, // 学科
						question_ids: this.$route.query.id /* 题目ID */
					})
					.then(res => {
						// console.log(res)
						if (res.data.id) {
							this.$message({
								message: '新建成功!',
								type: 'success'
							});
							this.$router.push('/Mine');
							localStorage.removeItem('arr1');
						}
					});
			}
		},
		Delete(val) {
			this.deleteId = val;
		}
	}
};
</script>

<style lang="scss" scoped>
.mine_list {
	padding: 0 220px;
	background-color: #ffffff;
}
.btn {
	padding: 0 220px 20px;
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/mine/exercise.vue